// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1JN69","decsription":"App_decsription__2HHG4","annotatedCode":"App_annotatedCode__T31TE","titleNote":"App_titleNote__1CTEP","warning":"App_warning__1Owxr"};